import PostcodeUpload from './paf-upload-screen';

export default PostcodeUpload;
